import axiosPost from '../axiosPost';

export const tiposDeImagenIns = async (arg) => {
    const { nombre, codigo, bucket, folder} = arg;

    const body = {
        "service": "TipoDeImagenIns",
        "params": {
            "tipoDeImagenNombre": nombre,
            "tipoDeImagenCod": codigo,
            "tipoDeImagenBucket": bucket,
            "tipoDeImagenFolder": folder
        }
    }

    try {
        const result = await axiosPost('Y', body, arg)
        return result.data
    } catch (err) {
        console.log(err)
    }
};